import React from "react";

import MainIcon from "./icons/MainIcon";

const LogoMain = ({ className }) => {
  return <MainIcon className={`w-full ${className}`} />;
};

export default LogoMain;
